import { render, staticRenderFns } from "./RemoveLawyerPartyStep.vue?vue&type=template&id=b220f8c6"
import script from "./RemoveLawyerPartyStep.vue?vue&type=script&lang=ts"
export * from "./RemoveLawyerPartyStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports